import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  language: 'javascript',
  executionTier: 'sandboxed',
  jsCode: `// Available variables:
// - items: Input data from previous node (array)
// - input: Raw input data object
// - $node: Access previous node outputs: $node["NodeName"].json
// - $vars: Workflow variables
// - $loop: Loop context (if inside a loop)
//
// Use 'return' statement to return data

// Example: Transform items array
return items.map(item => ({
  ...item,
  processed: true,
  timestamp: new Date().toISOString()
}));`,
  pythonCode: `# Available variables:
# - items: Input data from previous node (list)
# - input: Raw input data (dict)
# - $node: Access previous node outputs
# - $vars: Workflow variables (dict)
# - $loop: Loop context (if inside a loop)
#
# Assign result to 'result' variable

# Example: Transform items list
result = [
    {**item, "processed": True, "timestamp": datetime.now().isoformat()}
    for item in items
]`,
};

export default defaults;
